var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Form, Button, SubmitButton, Icon, Pill } from "@brushfire/ui";
import { useHistory, useLocation } from "react-router-dom";
import { InputGroup } from "react-bootstrap";
import WidgetFieldSet from "../../../../Helpers/WidgetFieldset";
import { useDispatch } from "react-redux";
import { setFormIsSubmitting } from "../../../../../store/AppState/actions";
import { useSeatCode } from "../../../../../hooks/useSeatCode";
var AccessCodeInput = function (_a) {
    var _b, _c;
    var eventData = _a.eventData, codeType = _a.codeType;
    var _d = __read(useState(false), 2), hasError = _d[0], setHasError = _d[1];
    var history = useHistory();
    var search = useLocation().search.toLowerCase();
    var typeCode = (_b = new URLSearchParams(search).get("typecode")) !== null && _b !== void 0 ? _b : "";
    var access = (_c = new URLSearchParams(search).get("access")) !== null && _c !== void 0 ? _c : "";
    var queryParams = new URLSearchParams(search);
    var _e = useSeatCode(), seatCode = _e.seatCode, setSeatCode = _e.setSeatCode, clearSeatCode = _e.clearSeatCode;
    var dispatch = useDispatch();
    var onSubmit = function (values, formikHelpers) {
        dispatch(setFormIsSubmitting(true));
        if (values.accessCode !== null) {
            if (queryParams.has(codeType.toLowerCase())) {
                queryParams.delete(codeType.toLowerCase());
            }
            if (codeType === "seatCode") {
                setSeatCode(values.accessCode);
            }
            queryParams.append(codeType, values.accessCode);
            history.push({
                search: queryParams.toString(),
            });
            formikHelpers.resetForm({ values: { accessCode: "" } });
            formikHelpers.setSubmitting(false);
            dispatch(setFormIsSubmitting(false));
        }
    };
    var removeSeatCode = function () {
        clearSeatCode();
        if (queryParams.has(codeType.toLowerCase())) {
            queryParams.delete(codeType.toLowerCase());
            history.push({
                search: queryParams.toString(),
            });
        }
    };
    useEffect(function () {
        if (codeType === "access") {
            setHasError(!!(access && !eventData.accessCodeIsValid));
        }
        else if (codeType === "typeCode") {
            setHasError(!!(typeCode && !eventData.typeCodeIsValid));
        }
    }, [eventData.accessCodeIsValid, access, eventData.typeCodeIsValid, typeCode]);
    return (_jsx(_Fragment, { children: _jsx(Form, __assign({ onSubmit: onSubmit, initialValues: { accessCode: typeCode !== null && typeCode !== void 0 ? typeCode : null }, validateOnChange: false, validateOnBlur: false, useUnsavedPrompt: false }, { children: function (_a) {
                var formikContext = _a.formikContext;
                return (_jsxs(WidgetFieldSet, { children: [_jsxs(InputGroup, __assign({ className: "access-code-input" }, { children: [_jsx(Form.Field, { label: "Access Code", id: "accessCode", name: "accessCode", hiddenLabel: true, onBlur: function () {
                                        if (hasError) {
                                            setHasError(false);
                                        }
                                    }, hasError: hasError, errorValue: hasError ? "Sorry, the code you supplied is not valid." : "", placeholder: "Access Code" }), _jsx(InputGroup.Append, { children: _jsx(SubmitButton, __assign({ component: Button, type: "submit", purpose: "secondary", onClick: function (evt) {
                                            evt.stopPropagation();
                                            evt.preventDefault();
                                            formikContext.submitForm();
                                        } }, { children: _jsx(Icon, { icon: "check" }) })) })] })), codeType === "seatCode" && seatCode && (_jsx(Pill, { purpose: "light", text: seatCode, onRemoveClick: function () {
                                removeSeatCode();
                            }, className: "round m-bottom-sm" }))] }));
            } })) }));
};
export default AccessCodeInput;
